import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Button, Row, Col, UncontrolledTooltip, InputGroup, Input, FormGroup, Label, InputGroupText } from 'reactstrap';
import * as actions from '../actions/Users';
import { getUser } from '../actions/User';
import { deleteContacts, getContacts } from '../actions/Contacts';
import Breadcrumb from '../components/AdminBreadcrumb';

import ContactsList from '../components/contacts/List'

class ContactList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayConfirmation: false,
            selectedUsers: [],
            disableDelete: true
        }
    }

    componentDidMount() {
        this.props.actions.getContacts();
    }

    componentWillUnmount() {
        this.props.actions.clearUsersState();
    }

    handleSelect = (id) => {
        this.props.actions.getUser(id);
        this.props.history.push(`users/user/${id}`, { id })
    };

    handleDeleteClick = (e) => this.setState({ displayConfirmation: this.state.selectedUsers.length > 0, disableDelete: true });

    handleDeleteConfirmationToggle = () => {
        this.setState({ displayConfirmation: !this.state.displayConfirmation, disableDelete: false });
    }

    handleSaveNewUser = (newUser, firstName, lastName) => {
        this.props.actions.saveNewUser(this.role, newUser, firstName, lastName)
    };

    setDisableTrash = () => {
        this.setState({ disableDelete: true });
    }

    setEnableTrash = () => {
        this.setState({ disableDelete: false });
    }

    render() {
        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <ContactsList
                    title={'Contacts'}
                    deleteContacts={this.props.actions.deleteContacts}
                    showProgramColumn={false}
                    setDisableTrash={this.setDisableTrash}
                    setEnableTrash={this.setEnableTrash}
                    data={this.props.contacts}
                    onSelect={this.handleSelect}
                    onSelectionChanged={this.handleSelectionChanged}
                    roles={this.props.roles}
                    programs={this.props.programs}
                />
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        newUserId: state.Users.get('newUserId'),
        contacts: state.SearchResults.get('contacts').toJS(),
        roles: state.Users.get('roles'),
        users: state.Users.get('userList'),
        showNewUserModal: state.Users.get('showNewUserModal'),
        passwordValidationMessages: state.Users.get('passwordValidationMessages').toJS(),
        programs: state.Programs.toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, deleteContacts, getUser, getContacts }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactList);